import React from 'react';
import ReactMarkdown from 'react-markdown';
import { reactMarkDown } from './markdown/markdown-styles.module.scss';

export const Markdown = ({ text }: { text: string }) => (
  <ReactMarkdown className={reactMarkDown}>{text}</ReactMarkdown>
);
